import * as React from "react";
import { OwnerUser } from "../../../../core";
import defaultImage from "../../../../assets/images/user-noimage.png";
import { UserAvatar } from "../../../../components/render-file/UserAvatar";

interface ICrmAgentColumnProps {
  user?: OwnerUser;
  title?: string;
  className?: string;
}

const OwnerBlock: React.FunctionComponent<ICrmAgentColumnProps> = (props) => {
  return (
    <div className={props.className}>
      <div className="mr-3 text-right">
        {props.user ? (
          <h6 className="mb-0 font-weight-semibold">
            {props.user?.knownAs || props.user?.name}
          </h6>
        ) : (
          <h6 className="mb-0 font-weight-semibold">Not Assigned</h6>
        )}

        <p className="mb-0 font-xs font-weight-semibold text-gray-500">
          {props.title}
        </p>
      </div>
      <div className="avatar-progress avatar-progress--sm position-relative cursor-pointer">
        <svg>
          <circle r="16" cx="50%" cy="50%" className="default"></circle>
          <circle
            r="16"
            cx="50%"
            cy="50%"
            className="progress"
            stroke-dasharray="117"
            stroke-dashoffset="45"
          ></circle>
        </svg>
        <UserAvatar
          id={props.user?._id}
          className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle img-contain"
          alt=""
          title={props.user?.name}
          imageUrl={props.user?.avatar?.location}
          image={props.user?.photo}
        ></UserAvatar>
      </div>
    </div>
  );
};

export default OwnerBlock;
